import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';

import { navigateParentToDtc } from '@/features/app/MessageHandler';
import TimestampAndMileage from '@/features/engineoil/components/TimestampAndMileage';
import { SOURCE_DEVICE } from '@/features/engineoil/utils/constants';
import { getBarColorClass, getThresholdClass } from '@/features/engineoil/utils/utils';
import type { EngineOil } from '@/generated/GeneratedApiTypes';
import AnalyticsEvents from '@/utils/analytics/AnalyticsEvents';
import BasePanel from './BasePanel';

interface Tbm3SsSingleCardProps {
    engineOil: EngineOil;
}

// Tbm3SsSingle = TBM3 device, sensor-signal-single reading.
// State is always unknown; only status (danger/warning/normal) is resolved from percentage.
const Tbm3SsSingleCard = ({ engineOil }: Tbm3SsSingleCardProps) => {
    const { status, measurement, measured_at, active_dtc } = engineOil;

    const hasActiveDtc = active_dtc != null;

    const thresholdClass = getThresholdClass(status);
    const barColorClass = getBarColorClass(status);
    const percentage = measurement != null ? Math.round(measurement) : 0;

    return (
        <BasePanel
            thresholdClass={thresholdClass}
            testId="card-workshop-tbm3-sensor_signal_single"
            subTitleKey="intl-msg:engineOil.card.ssSingle.subTitle"
        >
            <div className="display-flex flex-wrap">
                <TimestampAndMileage timestamp={measured_at.date} mileage={measured_at.mileage_km} />
            </div>

            <div className="width-100pct display-flex align-items-center padding-top-10">
                <div className="progress margin-0 flex-1-0" style={{ height: '10px' }}>
                    <div className={`progress-bar ${barColorClass}`.trim()} style={{ width: `${percentage}%` }} />
                </div>
                <div className="margin-left-10 text-color-gray-darkest">{`${percentage} %`}</div>
            </div>

            <div className="text-size-14 text-color-darkest margin-top-10 margin-bottom-10">
                <span className="uikit-icon icon-dangerousgoods margin-right-5" />
                <FormattedMessage id="intl-msg:engineOil.card.ssSingle.banner.notAccurate" />
            </div>

            {hasActiveDtc && (
                <div
                    className={
                        'margin-top-15 margin-bottom-0 display-flex ' +
                        'justify-content-between align-items-center text-size-12'
                    }
                >
                    <div className="text-color-danger display-flex align-items-center">
                        <span className="uikit-icon icon-error-sign margin-right-2" />
                        <FormattedMessage id={`intl-msg:engineOil.card.workshop.dtc.${active_dtc.type}`} />
                    </div>
                    <Button
                        bsStyle={Button.DANGER}
                        variant={Button.VARIANT_OUTLINE}
                        bsSize={Button.XS}
                        style={{ borderRadius: '5px' }}
                        onClick={() => {
                            AnalyticsEvents.clickSpnBtn(SOURCE_DEVICE.TBM3);
                            navigateParentToDtc(active_dtc.spn);
                        }}
                    >
                        <FormattedMessage id="intl-msg:engineOil.dtc.spn" />
                        &nbsp;
                        {active_dtc.spn}
                    </Button>
                </div>
            )}
        </BasePanel>
    );
};

export default Tbm3SsSingleCard;
